import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock, Eye } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface ClientStatusBadgeProps {
  status: "active" | "recent" | "inactive" | "unknown";
  text: string;
  isShared?: boolean;
}

const ClientStatusBadge = ({ status, text, isShared = false }: ClientStatusBadgeProps) => {
  // Only show the "Shared" badge if isShared is true, always with the lighter green color
  if (isShared) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <Badge 
                variant="outline"
                className="grayscale-0 opacity-100 text-green-700 bg-green-100 border-green-200 hover:bg-green-200 cursor-default"
              >
                <Eye className="w-3 h-3 mr-1" />
                Shared
              </Badge>
            </div>
          </TooltipTrigger>
          <TooltipContent side="top" align="center" className="z-50">
            This client is sharing their journal with you.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  // If not shared, do not show any badge
  return null;
};

export default ClientStatusBadge;
